import React, { useEffect, useState } from "react";
import {
    Typography,
    Grid,
    Avatar,
    Paper,
    makeStyles,
    Card,
    Button,
    CardContent,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import { Link, Redirect, useLocation } from "react-router-dom";

import routes from "../../utils/routes.json";
import APIroutes from "../../utils/apiRoutes.json";
import UserInfo from "../../model/userInfo";
import api from "../../utils/api";

const useStyles = makeStyles((theme) => ({
    avatar: {
        width: "110px",
        height: "110px",
    },
    avatarsGrid: {
        maxWidth: "500px",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerText: {
        textAlign: "center",
    },
    fullHeight: {
        height: "100%",
    },
    fullWidth: {
        width: "100%",
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            background: theme.palette.primary.main,
        },
        width: "40%",
        maxWidth: "300px",
        borderRadius: "4px",
    },
    share: {
        width: "1.5em",
        height: "1.5em",
    },
    noPadding: {
        padding: "0",
    },
    middleGrid: {
        maxWidth: "800px",
    },
    lowerGrid: {
        maxWidth: "600px",
    },
    blackText: {
        color: "black",
    },
    shareButton: {
        margin: "0 auto",
    },
    stats: {
        ["@media (min-width: 780px)"]: {
            transform: "scale(1.4)",
        },
    },
}));

type locationState = {
    user: UserInfo;
    correctAnswers: number;
    timePerQuestion: number;
    categoryIds: string[],
}

export default function DailyResult(): JSX.Element {

    const { t } = useTranslation();
    const classes = useStyles();
    const location: locationState = useLocation<locationState>().state;
    const [place, setState] = useState();

    if (!location)
        return <Redirect to={routes.menu} />;

    useEffect(() => {
        api.get(
            APIroutes.daily_rank_get,
        )
            .then((response: any) => {
                console.log(response);
                setState(response)
            });
        //console.log(response);
        //setState(response);
    });

    console.log(place);
    

    return (
        <MainScreen lower={false} back={true} backPath={routes.menu}>
            <Grid container direction="column" justify="space-around" classes={{ root: classes.fullHeight }}>
                <Card elevation={0} classes={{ root: classes.fullWidth }}>
                    <CardContent>
                        <Grid
                            container direction="row" justify="space-around"
                            className={`${classes.centerHorizontal} ${classes.avatarsGrid}`}
                        >
                            <Avatar
                                alt={location.user.name}
                                src={location.user.image}
                                className={classes.avatar}
                            />
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container direction="row" justify="space-evenly" className={`${classes.centerHorizontal} ${classes.middleGrid}`}>
                    <Paper elevation={0} className={`${classes.stats}`}>
                        <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                            {location.correctAnswers}
                        </Avatar>
                        <Typography variant="body2" classes={{ root: classes.centerText }}>
                            {t("practiceResult.correct")}
                        </Typography>
                    </Paper>
                    <Paper elevation={0} className={`${classes.stats}`}>
                        <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                            {location.timePerQuestion}
                        </Avatar>
                        <Typography variant="body2" classes={{ root: classes.centerText }}>
                            {t("practiceResult.time")}
                        </Typography>
                    </Paper>
                    <Paper elevation={0} className={`${classes.stats}`}>
                        <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                            {place}
                        </Avatar>
                        <Typography variant="body2" classes={{ root: classes.centerText }}>
                            {t("questionResult.Place")}
                        </Typography>
                    </Paper>
                </Grid>
                <Grid container direction="row" justify="center" className={`${classes.centerHorizontal} ${classes.lowerGrid}`}>
                    <Link
                        to={{
                            pathname: routes.practice,
                            state: { categoryIds: location.categoryIds },
                        }} className={`${classes.blackButton}`}
                    >
                    </Link>
                </Grid>
            </Grid>
        </MainScreen>
    );
}